































import Vue from 'vue'
import { Offer } from '@/store/interview/offers'
import { Booking } from '@/store/interview/bookings'
import ReportWidget from '@/components/interviews/Report.vue'
import BookingWidget from '@/components/interviews/BookingDetailsForInterviewer.vue'
import Artifacts from '@/components/artifacts/Artifacts.tsx'
import AuthorizationMixin from '@/routing/AuthorizationMixin'

export interface ComponentData {
  loading: boolean
  open?: any
}

export default Vue.extend({
  mixins: [AuthorizationMixin],
  computed: {
    caseId(): string {
      return this.$route.query.caseId || this.$store.getters.currentCaseId
    },
  },
  components: {
    Artifacts,
    Report: ReportWidget,
  },
  data(): ComponentData {
    return {
      loading: false,
      open: undefined,
    }
  },
})
